module.exports = __webpack_public_path__ + "img/Topic-globalhealth.ec371622.svg";